/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';
import { type OperationRequestBodyContent } from 'openapi-typescript-helpers';
import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type PostPlaygroundPathParams = NonNullable<operations['postPlayground']['parameters']['path']>;

export type PostPlaygroundRequestBody = OperationRequestBodyContent<operations['postPlayground']>;

export interface Input extends PostPlaygroundPathParams {
  apiVersion?: string;
  body: PostPlaygroundRequestBody;
}

export async function postPlayground(
  { apiVersion, body, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().POST('/internal/projects/{projKey}/playgrounds', {
    params: { path },
    body,
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
